import QR from "qrcode";
import { useEffect, useRef, useState } from "react";
import { Header } from "shared";
import styles from "./DonateInternational.styles";

const NAME = "UDRUGA 4 LISTA";
const ADDRESS = "ULICA SVETOG ROKA 19, 31000 OSIJEK";
const IBAN = "HR7824840081135136401";
const SWIFT = "RZBHHR2XXXX";
const DESCRIPTION = "DONATION";

const QRCodeData = [
	"BCD",
	"001",
	"1",
	"SCT",
	SWIFT,
	NAME,
	IBAN,
	"EUR100.00",
	DESCRIPTION,
].join("\n");

export const DonateInternational: React.FC = () => {
	const canvasRef = useRef<HTMLCanvasElement>(null);
	const [ibanCopied, setIbanCopied] = useState(false);
	const [swiftCopied, setSwiftCopied] = useState(false);
	const [nameCopied, setNameCopied] = useState(false);
	const [addressCopied, setAddressCopied] = useState(false);
	const [descriptionCopied, setDescriptionCopied] = useState(false);

	useEffect(() => {
		if (!canvasRef.current) return;
		QR.toCanvas(canvasRef.current, QRCodeData, { width: 256 });
	}, []);

	return (
		<div>
			<Header />
			<div css={styles.container}>
				<div css={styles.caption}>
					<h2 css={styles.heading}>Thank you for donating</h2>

					<div
						style={{
							display: "flex",
							flexDirection: "column",
							justifySelf: "center",
						}}
					>
						<p>
							This non-profit is financed exclusively via membership fees, which
							unfortunately isn't always enough for food and care for the horses
							providing the therapy.
						</p>
						<p>
							Help us by donating however much you can to the following bank
							account:
						</p>

						<canvas css={styles.image} ref={canvasRef} />

						<small style={{ marginTop: 32, textAlign: "center" }}>
							If the QR doesn't scan, you can copy the required details below
							into your banking app. Make sure to add the description too.
						</small>

						<button
							css={styles.clipboardText}
							type="button"
							disabled={nameCopied}
							onClick={() => {
								navigator.clipboard
									.writeText(NAME)
									.then(() => setNameCopied(true))
									.finally(() => setTimeout(() => setNameCopied(false), 3000));
							}}
						>
							Name: {NAME} {nameCopied ? "(copied)" : ""}
							<img src="icons/copy.png" alt="Copy" height={12} width={12} />
						</button>

						<button
							css={styles.clipboardText}
							type="button"
							disabled={addressCopied}
							onClick={() => {
								navigator.clipboard
									.writeText(ADDRESS)
									.then(() => setAddressCopied(true))
									.finally(() =>
										setTimeout(() => setAddressCopied(false), 3000),
									);
							}}
						>
							Address: {ADDRESS} {addressCopied ? "(copied)" : ""}
							<img src="icons/copy.png" alt="Copy" height={12} width={12} />
						</button>

						<button
							css={styles.clipboardText}
							type="button"
							disabled={ibanCopied}
							onClick={() => {
								navigator.clipboard
									.writeText(IBAN)
									.then(() => setIbanCopied(true))
									.finally(() => setTimeout(() => setIbanCopied(false), 3000));
							}}
						>
							IBAN: {IBAN} {ibanCopied ? "(copied)" : ""}
							<img src="icons/copy.png" alt="Copy" height={12} width={12} />
						</button>

						<button
							type="button"
							disabled={swiftCopied}
							css={styles.clipboardText}
							onClick={() => {
								navigator.clipboard
									.writeText(SWIFT)
									.then(() => setSwiftCopied(true))
									.finally(() => setTimeout(() => setSwiftCopied(false), 3000));
							}}
						>
							SWIFT: {SWIFT} {swiftCopied ? "(copied)" : ""}
							<img src="icons/copy.png" alt="Copy" height={12} width={12} />
						</button>

						<button
							type="button"
							disabled={descriptionCopied}
							css={styles.clipboardText}
							onClick={() => {
								navigator.clipboard
									.writeText(DESCRIPTION)
									.then(() => setDescriptionCopied(true))
									.finally(() =>
										setTimeout(() => setDescriptionCopied(false), 3000),
									);
							}}
						>
							Description: {DESCRIPTION} {descriptionCopied ? "(copied)" : ""}
							<img src="icons/copy.png" alt="Copy" height={12} width={12} />
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
